import GHIsHukuku from "../pages/lawsuit-claims/GHIsHukuku";

export const DEMAND_TYPES = {
    GLOBAL_HUKUK_ISLERI: 1,
    BASKANLIK_TOPLANTI: 2,
    HISSE_ALIM_SATIM: 3,
    VEKALETNAME: 4,
    ORTAKLIKJV_KURULUSU: 5,
    ESAS_SOZLESME: 6,
    YONETIM_KURULU_KARARLARI: 7,
    YURTDISI_ISTIRAKLERI_DIGER: 8,
    REKABET_HUKUKU_IZIN_BASVURU: 9,
    REKABET_HUKUKU_SORUSTURMALAR: 10,
    YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI: 11,
    GH_IS_HUKUKU: 81,

    DUE_DILIGENCE: 12,
    SIRKETLER_HUKUKUNA_ILISKIN_GORUS: 13,
    SIRKETLER_HUKUKU_TOPLANTI: 14,
    SIRKETLER_HUKUKU_EGITIM: 15,

    DAVA_YENI_TALEP: 16,
    ICRA_TAKIBI: 17,
    SAVCILIK: 18,
    IS_HUKUKU_FESIH: 19,
    HACIZ_IHBARNAMELERI: 20,
    BASIN_HUKUKU: 21,
    IHTARNAME_HAZIRLANMASI: 22,
    MAHKEMELERDEN_GELEN_YAZILARA_CEVAP: 23,
    DAVA_ICRA_HUKUKU_RAPOR: 24,
    DAVA_ICRA_TOPLANTI: 25,
    DAVA_ICRA_EGITIM: 26,
    YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI: 80,
    DAVA_ICRA_H_YURTDISI_IHTILAFLARIN_KORDINASYONU: 69,

    SOZLESME: 27,
    SOZLESMELERLE_ILGILI_SORU: 28,
    SOZLESMELER_TOPLANTI: 29,
    SOZLESMELER_EGITIM: 30,

    FMH_YENI_DAVA: 31,
    FMH_ALEYHE_DAVA:83,
    MARKA_PATENT: 32,
    FMH_IHTARNAME_HAZIRLANMASI: 33,
    SINAI_MULKIYET_HAKLARI: 34,
    SINAI_HAKLAR_BEYAN: 70,
    REKLAM_SENARYOSU: 35,
    REKLAM_DIGER: 36,
    BILISIM_VE_INTERNET: 37,
    FMH_ILISKIN_HUKUKI_GORUS: 38,
    FMH_ILISKIN_RAPORLAMALAR: 39,
    FMH_RAPORLAMALAR: 82,
    FMH_TOPLANTI: 40,
    FMH_EGITIM: 41,

    HUKUKI_GORUS_TALEPLERI: 42,
    MEVZUAT_INCELEME: 43,
    SPK_MEVZUATI: 44,
    HALKA_ACIK_SIRKET: 45,
    HALKA_ARZ_ISLEMLERI: 46,
    RESMI_MERCI_DENETIMLERI: 47,
    RESMI_KURUM_TALEP: 48,
    SIRKET_YONETMELIK: 49,
    DIGER_GENEL_HUKUK: 50,
    GENEL_HUKUK_TOPLANTI: 51,
    GENEL_HUKUK_EGITIM: 52,
    GENEL_H_IHTARNAME:98,
    GENEL_H_KISISEL_VERILER_SURECLER: 79,

    BAKANLIK_RESMI_YANIT: 53,
    KANUN_VE_YONETMELIK: 54,
    ULUSLARARASI_REGULASYONLAR: 55,
    REKLAM_VE_TANITIM: 56,
    CEVRE_KANUNU: 57,
    YASAL_DENETIMLER: 58,
    REGULASYON_DIGER: 59,
    REGULASYON_TOPLANTI: 60,
    REGULASYON_EGITIM: 61,

    TICARET_MUTALAA: 63,
    ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI: 64,

    TIO_MUTALAA:84,
    TIO_IHTARNAME:85,
    TIO_SOZLESME: 86,
    TIO_SOZLESMELERLE_ILGILI_SORU: 87,
    TIO_VEKALETNAME_HAZIRLANMASI: 88,
    TIO_DAVA_YENI_TALEP: 89,
    TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI: 90,
    TIO_SAVCILIK: 91,
    TIO_ICRA_TAKIBI:92,
    TIO_HACIZ_IHBARNAMELERI:93,
    TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP:94,
    TIO_BASIN_HUKUKU:95,
    TIO_RAPORLAMALAR:96,
    TIO_SIRKETEGITIM:97,

    PLADIS_SOZLESMEHAZIRLANMASI: 125,
    PLADIS_SOZLESMEUYUSMAZLIKLAR: 126,
    PLADIS_YENIDAVA: 127,
    PLADIS_ALEYHEACILAN: 128,
    PLADIS_ICRA: 129,
    PLADIS_SAVCILIK: 130,
    PLADIS_MUTALAA: 131,
    PLADIS_HACIZ: 132,
    PLADIS_MAHKEMELERDENGELENYAZILAR: 133,
    PLADIS_ISHUKUKUFESIH: 134,
    PLADIS_RAPORLAMALAR: 135,
    PLADIS_EGITIM: 136,
    PLADIS_TOPLANTI: 137,
    PLADIS_IHTARNAME_HAZIRLANMASI: 150,
    PLADIS_VEKALETNAME_HAZIRLANMASI: 151,
    MP_MARKAPATENTENDUSTRIYELTASARIM: 138,
    MP_SINAIHAKLARSOZLESMEHAZIRLAMA: 139,
    MP_YURTDISIYENIDAVAACILMASI: 140,
    MP_YURTDISIALEYHEDAVATAKIBI: 141,
    MP_YURTDISIIHTARNAMEHAZIRLANMASI: 142,
    MP_EGITIM: 143,
    MP_TOPLANTI: 144,
    MP_RAPORLAMALAR: 145,
    MP_MUTALAADANISMA: 146,
    TH_KAMULASTIRMA: 148,
    TH_YURTDISIDAVA: 149,
};

export const CASE_TYPES = {
  CEZA: 10,
  DIGER: 8,
  FIKRI_HAKLAR: 5,
  FIKRI_HAKLAR_CEZA: 122,
  FIKRI_HAKLAR_DIGER: 123,
  FIKRI_HAKLAR_HUKUK: 120,
  FIKRI_HAKLAR_ICRA: 121,
  ICRA: 11,
  IDARI: 9,
  IS: 6,
  TUKETICI: 4,
  VERGI: 7
}

export const CASE_TYPES1 = {
  KAMULASTIRMASIZ_EL_ATMA_DAVALARI: 161,
  YENI_SAVCILIK_SIKAYETI_YAPILMASI: 140,
  ALEYHE_SAVCILIK_SIKAYETININ_TAKIBI: 141,
  ARABULUCULUK_SURECLERI: 156,
  ICRA_TAKIBINE_BAGLI_DAVALAR: 157,
  VERGI_DAVALARI: 158,
  IDARI_DAVALAR: 159,
  ALACAK_DAVALARI: 160,
  CEZA_DAVALARI: 162,
  TAZMINAT_DAVALARI: 163,
  DIGER_DAVALAR: 164,
  IS_DAVALARI: 175,
  KIRA_DAVALARI: 176,
  ALACAK_DAVALAR: 177,
  KAMULASTIRMA_DAVALARI: 178,
  TUKETICI_DAVALARI: 179,
}

export const CASE_TYPES2 = {
  TUKETICI: 167,
  HIZMET_TESPITI: 183,
  TICARI_SIRRIN_IFSASI: 144,
  GUVENI_SUISTIMAL: 143,
  KIRA: 168,
  HIRSIZLIK: 142,
  ODEME_EMRININ_IPTALI: 170,
  VERGI_CEZA_IHBARNAMESININ_IPTALI: 169,
  FINANSMAN_GIDERI_KISITLAMALARI_AZALTMA_IADE: 174,
  YONETMELIK_GENEL_TEBLIG_IPTALI: 173,
  EMLAK_VERGISI_KARARINA_ITIRAZ: 172,
  DEVREDEN_KDV_AZALTIMININ_IPTALI: 171,
  DIGER: 155,
  IMAR_KIRLILIGINE_SEBEBIYET_VERMEK: 154,
  KULTUR_VE_TABIAT_VARL_KORUMA_KNA_MUHALEFET: 153,
  IMAR_MEVZUATINA_AYKIRILIK: 152,
  GIDA_MEVZUATINA_AYKIRILI: 151,
  OLUMLU_VEYA_YARALANMALI_DIGER_KAZALAR: 150,
  OLUMLU_VEYA_YARALANMALI_IS_KAZAS: 149,
  HAKSIZ_REKABE: 148,
  SOMERA_SIKAYETI: 147,
  HAKARET_SOVME: 146,
  TEHDIT_SANTAJ: 145,
  TICARI: 166,
  IS: 165,
  IS_KAZASI: 182,
  ISCILIK_DAVALARI: 181,
  ISE_IADE: 180,
}


export const DEMAND_TYPE_CASES_1 = {
  [DEMAND_TYPES.DAVA_YENI_TALEP]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.VERGI_DAVALARI,
    CASE_TYPES1.IDARI_DAVALAR,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMASIZ_EL_ATMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TAZMINAT_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR,
  ],
  [DEMAND_TYPES.TH_KAMULASTIRMA]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.VERGI_DAVALARI,
    CASE_TYPES1.IDARI_DAVALAR,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMASIZ_EL_ATMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TAZMINAT_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR,
  ],
  [DEMAND_TYPES.PLADIS_YENIDAVA]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.VERGI_DAVALARI,
    CASE_TYPES1.IDARI_DAVALAR,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMASIZ_EL_ATMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TAZMINAT_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR,
  ],
  [DEMAND_TYPES.TIO_DAVA_YENI_TALEP]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.VERGI_DAVALARI,
    CASE_TYPES1.IDARI_DAVALAR,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMASIZ_EL_ATMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TAZMINAT_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR,
  ],
  [DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.IS_DAVALARI,
    CASE_TYPES1.KIRA_DAVALARI,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TUKETICI_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR
  ],
  [DEMAND_TYPES.PLADIS_ALEYHEACILAN]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.IS_DAVALARI,
    CASE_TYPES1.KIRA_DAVALARI,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TUKETICI_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR
  ],
  [DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI]: [
    CASE_TYPES1.ARABULUCULUK_SURECLERI,
    CASE_TYPES1.ICRA_TAKIBINE_BAGLI_DAVALAR,
    CASE_TYPES1.IS_DAVALARI,
    CASE_TYPES1.KIRA_DAVALARI,
    CASE_TYPES1.ALACAK_DAVALAR,
    CASE_TYPES1.KAMULASTIRMA_DAVALARI,
    CASE_TYPES1.CEZA_DAVALARI,
    CASE_TYPES1.TUKETICI_DAVALARI,
    CASE_TYPES1.DIGER_DAVALAR
  ],
  [DEMAND_TYPES.SAVCILIK]: [
    CASE_TYPES1.YENI_SAVCILIK_SIKAYETI_YAPILMASI,
    CASE_TYPES1.ALEYHE_SAVCILIK_SIKAYETININ_TAKIBI,
  ],
  [DEMAND_TYPES.TIO_SAVCILIK]: [
    CASE_TYPES1.YENI_SAVCILIK_SIKAYETI_YAPILMASI,
    CASE_TYPES1.ALEYHE_SAVCILIK_SIKAYETININ_TAKIBI,
  ]
}

export const DEMAND_TYPE_CASES_2 = {
  [CASE_TYPES1.ARABULUCULUK_SURECLERI]: [
    CASE_TYPES2.IS,
    CASE_TYPES2.TICARI,
    CASE_TYPES2.TUKETICI,
    CASE_TYPES2.KIRA,
    CASE_TYPES2.DIGER
  ],
  [CASE_TYPES1.IS_DAVALARI]: [
    
    CASE_TYPES2.ISE_IADE,
    CASE_TYPES2.ISCILIK_DAVALARI,
    CASE_TYPES2.IS_KAZASI,
    CASE_TYPES2.HIZMET_TESPITI
  ],
  [CASE_TYPES1.VERGI_DAVALARI]: [
    CASE_TYPES2.ODEME_EMRININ_IPTALI,
    CASE_TYPES2.DEVREDEN_KDV_AZALTIMININ_IPTALI,
    CASE_TYPES2.EMLAK_VERGISI_KARARINA_ITIRAZ,
    CASE_TYPES2.YONETMELIK_GENEL_TEBLIG_IPTALI,
    CASE_TYPES2.FINANSMAN_GIDERI_KISITLAMALARI_AZALTMA_IADE
  ],
  [CASE_TYPES1.YENI_SAVCILIK_SIKAYETI_YAPILMASI]: [
    CASE_TYPES2.HIRSIZLIK,
    CASE_TYPES2.GUVENI_SUISTIMAL,
    CASE_TYPES2.TICARI_SIRRIN_IFSASI,
    CASE_TYPES2.TEHDIT_SANTAJ,
    CASE_TYPES2.HAKARET_SOVME,
    CASE_TYPES2.SOMERA_SIKAYETI,
    CASE_TYPES2.HAKSIZ_REKABE,
    CASE_TYPES2.DIGER,
  ],
  [CASE_TYPES1.ALEYHE_SAVCILIK_SIKAYETININ_TAKIBI]: [
    CASE_TYPES2.OLUMLU_VEYA_YARALANMALI_DIGER_KAZALAR,
    CASE_TYPES2.OLUMLU_VEYA_YARALANMALI_IS_KAZAS,
    CASE_TYPES2.GIDA_MEVZUATINA_AYKIRILI,
    CASE_TYPES2.IMAR_MEVZUATINA_AYKIRILIK,
    CASE_TYPES2.KULTUR_VE_TABIAT_VARL_KORUMA_KNA_MUHALEFET,
    CASE_TYPES2.IMAR_KIRLILIGINE_SEBEBIYET_VERMEK,
    CASE_TYPES2.DIGER,
  ]
}

export const MASRAF_TAB_CASES = [
  DEMAND_TYPES.DAVA_YENI_TALEP,
  DEMAND_TYPES.TH_KAMULASTIRMA,
  DEMAND_TYPES.PLADIS_YENIDAVA,
  DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
  DEMAND_TYPES.PLADIS_ALEYHEACILAN,
  DEMAND_TYPES.ICRA_TAKIBI,
  DEMAND_TYPES.TIO_SAVCILIK,
  DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
  DEMAND_TYPES.FMH_ALEYHE_DAVA,
  DEMAND_TYPES.FMH_YENI_DAVA,
  DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
  DEMAND_TYPES.TIO_ICRA_TAKIBI
];